import React, { useState } from 'react';
import { DeviceDataAPIResponse } from '../../../../redux/commander/api/device.model';
import DeviceModel from '../../../../redux/commander/api/DeviceModel';
import { DeleteIcon } from '../../../../theme/icons';
import DeviceInformationUsageModal from './DeviceInformationUsage/DeviceInformationUsageModal';
import useStateBoolean from '../../../../util/hooks/useStateBoolean';
import { ButtonGroup, IconButton, ListItemIcon } from '@mui/material';
import DeviceDeleteWorkspaceModal from './DeviceDeleteWorkspace/DeviceDeleteWorkspaceModal';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { getPolyglot } from '../../../../i18n';
import { useUserRightUtil } from '../../../../util/rights';

export interface StoerkIdDeviceItemProps {
  devices: DeviceDataAPIResponse[];
  workspaceId: string;
}
const getRowId = (row: DeviceDataAPIResponse) => row?.uuid;

export function StoerkIdDeviceItem(props: StoerkIdDeviceItemProps) {
  const { devices, workspaceId } = props;
  const [isOpenDetails, openDetails, closeDetails] = useStateBoolean(false);
  const [isOpenDelete, openDelete, closeDelete] = useStateBoolean(false);
  const [deviceDetail, setDeviceDetail] =
    useState<DeviceDataAPIResponse | null>(null);

  const polyglot = getPolyglot();
  const userRightUtil = useUserRightUtil();
  const canRemoveDevice = userRightUtil.canRemoveWorkspaceDevice(workspaceId);

  const columns: GridColDef[] = [
    {
      field: 'avatar',
      headerName: '',
      sortable: false,
      align: 'center',
      flex: 1,
      renderCell: (params) => (
        <ListItemIcon>
          <img
            className="mini"
            style={{ width: '48px', height: '48px' }}
            src={DeviceModel.getDeviceIcon(params.row.iconURL)}
            alt="device-icon"
          />
        </ListItemIcon>
      ),
    },
    {
      field: 'name',
      headerName: polyglot.t('group.users.name'),
      flex: 4,
    },
    ...(canRemoveDevice
      ? [
          {
            field: 'actions',
            headerName: '',
            align: 'right' as const,
            sortable: false,
            flex: 1,
            renderCell: (params: any) => {
              const device = params.row as DeviceDataAPIResponse;
              return (
                <ButtonGroup sx={{ paddingRight: 1 }}>
                  <IconButton
                    aria-label="delete"
                    onClick={() => {
                      setDeviceDetail(device);
                      openDelete();
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </ButtonGroup>
              );
            },
          },
        ]
      : []),
  ];

  return (
    <>
      <DataGrid
        rows={devices}
        columns={columns}
        disableRowSelectionOnClick
        getRowHeight={() => 'auto'}
        getRowId={getRowId}
        onRowClick={(params) => {
          const device = params.row as DeviceDataAPIResponse;
          setDeviceDetail(device);
          openDetails();
        }}
        pageSizeOptions={[5, 10, 15, 25]}
        pagination={true}
        initialState={{
          pagination: {
            paginationModel: { pageSize: 10 },
          },
        }}
      />
      {deviceDetail && (
        <DeviceInformationUsageModal
          workspaceId={workspaceId}
          open={isOpenDetails}
          onClose={() => {
            closeDetails();
            setDeviceDetail(null);
          }}
          device={deviceDetail}
        />
      )}
      {deviceDetail && (
        <DeviceDeleteWorkspaceModal
          open={isOpenDelete}
          onClose={() => {
            closeDelete();
            setDeviceDetail(null);
          }}
          device={deviceDetail}
          workspaceId={workspaceId}
        />
      )}
    </>
  );
}

export default StoerkIdDeviceItem;
